import { api as todosApi } from '@home/constants/endpoints';

import { api as accountsApi } from '@accounts/constants/endpoints';

import { api as roomAdminApi } from '@room/constants/endpoints';

import { api as materialUploadApi } from '@materialUpload/constants/endpoints';

import { api as emailFeedbackApi } from '@emailFeedback/constants/endpoints';

import {
    attendee as searchAttendee,
    admin as searchAdmin,
    api as searchApi
} from '@search/constants/endpoints';

import {
    attendee as topicHubAttendee,
    admin as topicHubAdmin,
    api as topicHubApi
} from '@topicHub/constants/endpoints';

import {
    attendee as documentsAttendee,
    admin as documentsAdmin,
    api as documentsApi
} from '@documents/constants/endpoints';

import {
    api as formsApi,
    attendee as formsAttendee,
    admin as formsAdmin
} from '@forms/constants/endpoints';

import {
    attendee as meetingsAttendee,
    admin as meetingsAdmin,
    api as meetingsApi,
    deeplinks as meetingsDeeplinks
} from '@meetings/constants/endpoints';
import {
    api as minutesEditorApi,
    admin as minutesEditorAdmin,
    attendee as minutesEditorAttendee
} from '@meetings/details/minutes-editor/constants/endpoints';
import {
    admin as minutesHistoryAdmin,
    api as minutesHistoryApi
} from '@meetings/details/minutes-history/constants/endpoints';

import {
    attendee as membersAttendee,
    admin as membersAdmin,
    api as membersApi,
    adminPortal as membersAdminPortal
} from '@members/constants/endpoints';

import {
    attendee as tasksDecisionsAttendee,
    admin as tasksDecisionsAdmin,
    api as tasksDecisionsApi
} from '@tasksDecisions/constants/endpoints';

import { api as adminPortalOrganisationsApi } from '@organisations/constants/endpoints';
import { api as settingsApi, admin as settingsAdmin } from '@settings/constants/endpoints';

import { api as commentsApi } from './comments.endpoints';
import { api as roomsApi } from './rooms.endpoints';
import { api as supportPanelApi } from './supportPanel.endpoints';
import { api as userApi } from './user.endpoints';

export const attendee = {
    ...formsAttendee,
    ...meetingsAttendee,
    ...documentsAttendee,
    ...membersAttendee,
    ...topicHubAttendee,
    ...searchAttendee,
    ...tasksDecisionsAttendee,
    ...minutesEditorAttendee
};

export const admin = {
    ...formsAdmin,
    ...meetingsAdmin,
    ...documentsAdmin,
    ...membersAdmin,
    ...topicHubAdmin,
    ...searchAdmin,
    ...settingsAdmin,
    ...tasksDecisionsAdmin,
    ...adminPortalOrganisationsApi,
    ...minutesHistoryAdmin,
    ...minutesEditorAdmin
};

const teams = {
    deleteTeamsConnection: (activeRoomId: string) =>
        `/api/iam/msgraph/${activeRoomId}/revoke-credentials/`,
    getTeamsPreflight: () => `/api/iam/msgraph/preflight/`
};

export const api = {
    timestamp: (): string => '/api/timestamp/',
    globalSearch: (): string => '/api/global-search/',
    requestFeature: (): string => '/api/support/feature_request/',
    taskStatus: (token: string): string => `/api/tasks/status/${token}/`,
    logout: (): string => '/api/authenticate/logout/',
    websocketAuthToken: (): string => '/api/authenticate/websocket/issue/',
    notifications: (): string => `/api/notifications/`,
    ...accountsApi,
    ...formsApi,
    ...meetingsApi,
    ...documentsApi,
    ...membersApi,
    ...commentsApi,
    ...userApi,
    ...topicHubApi,
    ...searchApi,
    ...tasksDecisionsApi,
    ...adminPortalOrganisationsApi,
    ...supportPanelApi,
    ...materialUploadApi,
    ...roomsApi,
    ...roomAdminApi,
    ...settingsApi,
    ...teams,
    ...minutesHistoryApi,
    ...todosApi,
    ...minutesEditorApi,
    ...emailFeedbackApi
};

export const deeplinks = {
    ...meetingsDeeplinks
};

export const adminPortal = {
    ...membersAdminPortal
};
